import React from 'react';
import Hero from '../components/Hero';
import HowItWorks from '../components/HowItWorks';
import WhySmileVase from '../components/WhySmileVase';
import Pricing from '../components/Pricing';
import DesignLibrary from '../components/DesignLibrary';
import TargetAudience from '../components/TargetAudience';
import FAQ from '../components/FAQ';

export default function Home() {
  return (
    <>
      <Hero />
      <HowItWorks />
      <WhySmileVase />
      <Pricing />
      <DesignLibrary />
      <TargetAudience />
      <FAQ />
    </>
  );
}